import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const SKILL_TEMPLATE: ObjectTypeConfig = {
  actions: [
    {
      id: "add-to-my-skills",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "unpublish",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotUnpublish,
    },
  ],
};
